// Normalizes the provided url.
export const normalizeUrl = (urlString: string): string => {
  const urlObject = new URL(urlString);

  urlObject.hash = "";
  urlObject.search = "";

  urlObject.username = "";
  urlObject.password = "";

  return urlObject.toString();
};
